import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'lib-option-card-container',
  imports: [MatCardModule],
  template: `
    <mat-card class="option-card-container" role="region">
      <mat-card-header class="header">
        <mat-card-title class="title">
          <h2 id="card-title">{{ containerTitle() }}</h2>
        </mat-card-title>
        @if (subtitle()) {
          <mat-card-subtitle class="subtitle">
            <p id="card-subtitle">{{ subtitle() }}</p>
          </mat-card-subtitle>
        }
      </mat-card-header>
      <mat-card-content class="content">
        <ng-content></ng-content>
      </mat-card-content>
    </mat-card>
  `,
  styles: `
    @use 'breakpoints' as *;
    @use 'landing' as *;
    @use '@angular/material' as mat;
    @use 'theme' as theme;

    .option-card-container {
      background-color: mat.get-theme-color(theme.$light-theme, primary, 90);
      box-shadow: none;
      display: flex;
      align-items: center;
      gap: 16px;
      width: 95vw;

      @include web {
        padding: 22px 64px;
        max-width: 700px;
      }

      .header {
        text-align: center;
      }

      .title {
        @include landing-title();
        font-weight: 600;
        font-size: 21px;
        margin-bottom: 12px;

        @include tablet {
          font-size: 30px;
        }

        h2 {
          margin: 0;
          font-size: inherit;
          font-weight: inherit;
          color: inherit;
        }
      }

      .subtitle {
        color: mat.get-theme-color(theme.$light-theme, secondary, 10);
        font-weight: 500;
        line-height: 20px;
        font-size: 16px;

        p {
          margin: 0;
          font-size: inherit;
          font-weight: inherit;
          color: inherit;
          line-height: inherit;
        }
      }

      .content {
        align-self: stretch;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionCardContainerComponent {
  containerTitle = input('');
  subtitle = input('');
}
